function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as m } from "./index.es33.js";
import { clsx as p } from "./index.es105.js";
import { Typography as s } from "./index.es35.js";
import "./index.es36.js";
import t from "./index.es111.js";

var x = function x(_ref) {
  var r = _ref.isError,
      o = _ref.hint;
  return o ? m.jsx(s.Small, {
    className: p(t.hint, _defineProperty({}, t.errorHint, r)),
    "data-error": r,
    children: o
  }) : null;
};

export { x as InputHint };